import React from 'react';
import {
  getHealthTopicBackgroundColor,
  getHealthTopicIcon,
} from 'features/resources/utils/healthTopicUtils';
import type { CareProgramTopicCardProps } from 'features/resources/types';
import { ResourceBaseCard } from '../ResourceBaseCard/ResourceBaseCard';

export const CareProgramTopicCard: React.FC<CareProgramTopicCardProps> = ({
  healthTopic,
  title,
  onClick,
  disabled = false,
  selected = false,
  ariaLabel,
  variant = 'square',
}) => {
  const backgroundColor = getHealthTopicBackgroundColor(healthTopic);
  const IconComponent = getHealthTopicIcon(healthTopic);

  return (
    <ResourceBaseCard
      title={title}
      icon={<IconComponent />}
      backgroundColor={backgroundColor}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      selected={selected}
      ariaLabel={ariaLabel}
      testId="care-program-topic-card"
      className="care-program-topic-card"
    />
  );
};

export default CareProgramTopicCard;
